<template>
  <div id="app">
    <headTop index="1" :isScrollTop="true" />
    <div class="app-content">
      <keep-alive>
        <router-view class="router-view"></router-view>
      </keep-alive>
    </div>
    <foot />
  </div>
</template>

<script>
import headTop from "@/components/header/header";
import foot from "@/components/footer/footer";
export default {
  name: 'App',
  components: {
    headTop,
    foot
  },
  data() {
    return {
      type: false,
      list: []
    }
  },
  created() {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
#app {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  .app-content{
    flex: 1;
    width: 1030px;
    background: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue